const moment = require("moment");
require("moment/locale/es");

export default {
    computed: {
        getFormatoFechaToServer: function () {
            return "YYYY-MM-DDTHH:mm:ss.SSSZ";
        },
        getFormatoFechaToView: function () {
            return "DD/MM/YYYY HH:mm:ss";
        },
    },
    methods: {

    }
}